<template>
  <transition name="fade">
    <section class="End" v-show="store.state.isEnded">
      <section class="End-content">
        <p v-html="$t('end.text')"></p>
        <nav>
          <div class="End-mainBtn" @click="onRestart">
            <IconButton rounded>
              <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 186.6 196.97"><path fill="white" d="M23.79,0A10.37,10.37,0,0,0,13.42,10.37V58.43A10.37,10.37,0,0,0,23.79,68.8H72.58a10.37,10.37,0,1,0,0-20.74H46.68a72.57,72.57,0,1,1-25.94,55.61,10.37,10.37,0,1,0-20.74,0A93.31,93.31,0,1,0,34.15,31.52V10.37A10.35,10.35,0,0,0,23.79,0Z"/></svg>
            </IconButton>
            <span>{{$t('end.restart')}}</span>
          </div>
          <div class="End-btn" @click="onRestartR1">
            <IconButton rounded>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42.71 187.35"><path fill="white" d="M0,0H42.71V187.35H18.56V21.48H0Z"/></svg>
            </IconButton>
            <span>{{$t('end.restartr1')}}</span>
          </div>
          <div class="End-btn" @click="onRestartR2">
            <IconButton rounded>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.21 189.66"><path fill="white" d="M27.29,63.22H2.54l-.24-7.4q0-30.69,9.22-43.2T42.83,0Q84.2,0,84.21,45.87q0,30.95-30.94,89.18l-14.92,28-.73,1.46c-.41.81-1,2-1.7,3.52H82.27v21.6H0q2.06-4.6,8.61-18.32t17.84-37q9.59-20.39,16-34.58t9.71-23.3Q58.74,58.25,58.73,45q0-23.3-16.14-23.3Q27,21.72,27.06,50.6l.12,10.68Z"/></svg>
            </IconButton>
            <span>{{$t('end.restartr2')}}</span>
          </div>
        </nav>
        <p class="End-qrtext" v-html="$t('end.qrcode')"></p>

        <!-- <a class="End-btn" @click="isClosed = true">{{$t('end.btn')}}</a> -->
        <img class="End-qrimage" src="../../assets/images/qr-code.png" alt="">
      </section>
    </section>
  </transition>
</template>

<script>
import IconButton from '@/components/IconButton'

export default {
  components: {
    IconButton
  },
  inject: ['store'],
  data() {
    return {
      isClosed: false,
    }
  },
  methods: {
    onClick() {
      console.log('oooo');
    },
    onRestart() {
      this.$router.go()
    },
    onRestartR1() {
      this.store.restartroom(0)
    },
    onRestartR2() {
      this.store.restartroom(1)
    },
  }
}
</script>

<style lang="stylus" scoped>
.fade-enter-active,
.fade-leave-active
  transition: opacity 0.5s ease

.fade-enter-from,
.fade-leave-to
  opacity: 0
.End
  position fixed
  width 100%
  height 100%
  z-index 1000
  color white
  background-color rgba(6, 41, 92, 0.2) //06295c
  // background-image url('../../assets/bali-background.jpg')
  // background-size cover
  display flex
  align-items center
  justify-content center
  p
    font-size 1.5rem
  nav
    display flex
    justify-content center
    align-items  center
    margin 8vh 0
    > div
      text-align center
      margin 0 20px
      width 140px
      cursor pointer
      >>> .IconButton
        margin 0 auto
      span
        display block
        margin-top 20px
        text-transform uppercase
        font-family FuturaStd-bold, Arial, sans-serif
      &:hover
        >>> .IconButton
          background rgba(255, 255, 255, 0.6)

  .End-btn
      width 110px
      span
        font-size 0.9rem

  &-content
    padding 5%
    background rgba(255,255,255, 0.2)
    border-radius 3px
    text-align center
    font-size 1.3rem
    position relative
    p
      display flex
      align-content center
      align-items center
      justify-content center
      span
        display inline-block

      > img
        display inline-block
        width 120px
        margin 0 10px
  
  &-qrtext
    width 50%
    margin 0 auto
  &-qrimage
    position absolute
    right 40px
    bottom 40px
    display block
    width 130px
    object-fit contain
</style>